<!-- This div ID is used for Onfido's init() -->
<div [id]="getContainerId()"></div>
<onfido-close-popup></onfido-close-popup>
